<template>
  <AdminPanel />
</template>

<script>
import AdminPanel from '@/components/AdminPanel.vue'

export default {
  name: 'AdminPage',
  components: { AdminPanel },
}
</script>
